















































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import AuthService from "../services/auth-service";

@Component({
  components: {
    swiper,
    swiperSlide
  }
})
export default class PreCo extends Vue {
  private auth = new AuthService();
  swiperOptionVideo = {
    loop: true,
    slidesPerView: 3,
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true
    },
    keyboard: {
      enabled: true
    },
    breakpoints: {
      // when window width is <= 640px
      640: {
        slidesPerView: 1
      },
      1000: {
        slidesPerView: 2
      },
      1500: {
        slidesPerView: 3
      },
      2500: {
        slidesPerView: 3
      }
    }
  };

  options = {
    useEasing: true,
    useGrouping: true,
    separator: ",",
    decimal: ".",
    prefix: "",
    suffix: ""
  };

  joinNow() {
    this.$router.push('/pre-literary');
  }

  playVideo() {
    const video = document.getElementById("video1");

    if (video) {
      (video as any).play();
    }
  }

  mounted() {
    if (!this.auth.session){
      this.$router.push('/');
    }

    this.$root.$on("bv::modal::hide", bvEvent => {
      const iframe = bvEvent.target.getElementsByTagName("iframe")[0];
      if (iframe) {
        let src = bvEvent.target.getElementsByTagName("iframe")[0].src;
        iframe.src = src;
      }
    });
  }
}
